module.exports = __webpack_public_path__ + "img/reply.600e7e2d.svg";